var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39645 7.64645C5.2162 7.82669 5.20234 8.1103 5.35485 8.30645L5.39645 8.35355L9.89645 12.8536C10.0917 13.0488 10.4083 13.0488 10.6036 12.8536C10.7838 12.6733 10.7977 12.3897 10.6451 12.1936L10.6036 12.1464L6.4575 8L10.6036 3.85355C10.7838 3.67331 10.7977 3.3897 10.6451 3.19355L10.6036 3.14645C10.4233 2.9662 10.1397 2.95234 9.94355 3.10485L9.89645 3.14645L5.39645 7.64645Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.6f36e8576909fefc86ef6af2c45da507.svg";
export { ForwardRef as ReactComponent };